<template>
  <v-row>
    <PropertyDetailsDialog :selected="selectedProperty" v-model="showDetailsDialog"/>
    <v-col cols="12" class="text-right">
      <v-btn color="abadPrimary"
             @click="goto('/realEstate/property/new')"
             dark>
        Crear propiedad
      </v-btn>

      <v-btn @click="getProperties()"
             color="abadPrimary"
             icon>
        <v-icon>
          refresh
        </v-icon>
      </v-btn>

      <v-btn @click="resetFilters()"
             color="abadPrimary"
             text
             icon>
        <v-icon>
          mdi-filter-remove
        </v-icon>
      </v-btn>
    </v-col>

    <v-col cols="12">
      <v-data-table class="elevation-2 custom-table"
                    :headers="headers"
                    :items="properties"
                    :options.sync="options"
                    :footer-props="footerProps"
                    :server-items-length="totalProperties">

        <template v-slot:header.tipoPropiedad>
          <v-container fluid class="pa-0">
          <v-row align="center" justify="center" class="ma-0 flex-column">
          <v-menu max-height="300px">
            <template v-slot:activator="{ on }">
              <div class="pb-1">
                    <span v-on="on"
                          style="cursor: pointer"
                          class="hover"
                          :class="[filtros.tipoPropiedad ? 'select text-caption' : '']" >
                        {{ filtros.tipoPropiedad.label || 'Inmueble' }}
                    </span>
                <v-icon @click="filtros.tipoPropiedad = ''"
                        color="grey lighten-2"
                        size="small"
                        v-show="filtros.tipoPropiedad">
                  clear
                </v-icon>
              </div>
            </template>

            <v-list>
              <v-list-item @click="filtros.tipoPropiedad = item"
                           dense
                           :key="item.label"
                           v-for="item in propertiesTypes">
                <v-list-item-content>
                  <v-list-item-title>
                    {{item.label}}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>

           <div class="pb-1">
              <span style="cursor: pointer"
                    class="hover"
                    :class="[filtros.codigo ? 'select text-caption' : '']"
                    @click="showCodigoMenu">
                {{filtros.codigo || 'Código'}}
              </span>
                <v-icon @click="filtros.codigo = ''"
                        color="grey lighten-2"
                        size="small"
                        v-if="filtros.codigo">
                  clear
                </v-icon>
          </div>

          <v-menu :close-on-click=true
                  :close-on-content-click="false"
                  max-height="200px"
                  max-width="150px"
                  v-model="showCodigoDialog"
                  :position-x="x"
                  :position-y="y"
                  absolute>
            <v-card tile class="pa-3">
              <v-text-field outlined
                            hide-details
                            label="# Código"
                            v-model="codigo"
                            autofocus
                            append-icon="mdi-send"
                            @click:append="setCodigo"
                            @keyup.enter="setCodigo">
              </v-text-field>
            </v-card>
          </v-menu>
          <v-menu max-height="300px">
            <template v-slot:activator="{ on }">
              <div class="pb-1">
                    <span v-on="on"
                          style="cursor: pointer"
                          class="hover"
                          :class="[filtros.proposito ? 'select text-caption' : '']" >
                        {{filtros.proposito.label || 'Propósito'}}
                    </span>
                <v-icon @click="filtros.proposito = ''"
                        color="grey lighten-2"
                        size="small"
                        v-if="filtros.proposito">
                  clear
                </v-icon>
              </div>
            </template>

            <v-list>
              <v-list-item @click="filtros.proposito = item"
                           dense
                           :key="item.label"
                           v-for="item in purposeForFilters">
                <v-list-item-content>
                  <v-list-item-title>
                    {{item.label}}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>
           </v-row>
          </v-container>
        </template>

        <template v-slot:header.urbanizacion>
          <v-container fluid class="pa-0">
          <v-row align="center" justify="center" class="ma-0">
          <div>
            <span @click="showUnidadMenu"
                  style="cursor: pointer"
                  class="hover"
                  :class="[filtros.urbanizacion ? 'select text-caption' : '']" >
                  {{filtros.urbanizacion && filtros.urbanizacion.urbanizacion.toUpperCase() || 'Unidad'}}
            </span>

            <v-icon @click="filtros.urbanizacion = ''"
                    color="grey lighten-2"
                    size="small"
                    v-if="filtros.urbanizacion">
              clear
            </v-icon>
          </div>

          <v-menu :close-on-click=true
                  :close-on-content-click="false"
                  max-height="300px"
                  v-model="showUnidadDialog"
                  :position-x="x"
                  :position-y="y"
                  absolute>
            <v-card :loading="loading"
                    tile>
              <v-text-field flat
                            hide-details
                            label="Buscar Unidad"
                            solo
                            v-model.trim="unidad"
                            autofocus
                            @input="getUnidades(unidad)"
                            append-icon="mdi-magnify">
              </v-text-field>

              <v-divider/>

              <v-card-text v-if="showMessage">
                <div class="d-flex align-center justify-center">
                  <v-icon class="mr-3" color="error">
                    mdi-alert-circle
                  </v-icon>
                  No encontramos coincidencias
                </div>
              </v-card-text>

              <v-list class="v-scroll-y"
                      v-if="unidades.length > 0">
                <v-list-item @click="getListUnidades(u)"
                             dense
                             :key="JSON.stringify(u)"
                             v-for="u in unidades">
                  <v-list-item-content>
                    <v-list-item-title>
                      {{u.urbanizacion.toUpperCase()}}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card>
          </v-menu>
          </v-row>
          </v-container>
        </template>

        <template v-slot:header.zonas>
          <v-container fluid class="pa-0">
            <v-row align="center" justify="center" class="ma-0 flex-column">
              <div class="pb-1 text-center">
                    <span @click="showZonesMenu"
                          style="cursor: pointer;"
                          class="hover text-center"
                          :class="[filtros.zona ? 'select text-caption' : '']" >
                          {{ filtros.zona.nombre || 'Zona'}}
                    </span>
              <v-icon @click="filtros.zona = ''"
                      color="grey lighten-2"
                      size="small"
                      v-if="filtros.zona">
                clear
              </v-icon>
              </div>

          <v-menu :close-on-click="true"
                  :close-on-content-click="false"
                  max-height="300px"
                  v-model="showZonesDialog"
                  :position-x="x"
                  :position-y="y"
                  absolute>
            <v-card tile>
            <v-autocomplete :items="zones"
                            v-model="zona"
                            item-text="nombre"
                            item-value="id"
                            label="Buscar Zona"
                            flat
                            solo
                            prepend-inner-icon="mdi-magnify"
                            hide-details
                            no-data-text="No hay datos"
                            return-object
                            @input="setZone">
            </v-autocomplete>
              <v-divider/>

            <!--   <v-list class="v-scroll-y">
                <v-list-item @click="getSectors(itemZone)"
                             dense
                             :key="JSON.stringify(itemZone)"
                             v-for="itemZone in zones">
                  <v-list-item-content>
                    <v-list-item-title>
                      {{itemZone.nombre.toUpperCase()}}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list> -->
            </v-card>
          </v-menu>

          <div class="pb-1 text-center">
                <span @click="showSectorsMenu"
                      style="cursor: pointer;"
                      class="hover"
                      :class="[filtros.sector ? 'select text-caption' : '']" >
                    {{filtros.sector && filtros.sector.nombre || 'Sector'}}
                </span>
            <v-icon @click="filtros.sector = ''"
                    color="grey lighten-2"
                    size="small"
                    v-if="filtros.sector">
              clear
            </v-icon>
          </div>

          <v-menu :close-on-click="true"
                  :close-on-content-click="false"
                  max-height="300px"
                  v-model="showSectorsDialog"
                  :position-x="x"
                  :position-y="y"
                  absolute>
            <v-card tile>
              <v-autocomplete :items="sectors"
                            v-model="sector"
                            item-text="nombre"
                            item-value="id"
                            return-object
                            label="Buscar Sector"
                            flat
                            solo
                            prepend-inner-icon="mdi-magnify"
                            hide-details
                            no-data-text="No hay datos"
                            @input="setSector">
              </v-autocomplete>
              <v-divider/>

              <!-- <v-list>
                <v-list-item @click="getNeighborhoods(itemSector)"
                             dense
                             :key="JSON.stringify(itemSector)"
                             v-for="itemSector in sectors">
                  <v-list-item-content>
                    <v-list-item-title>
                      {{itemSector.nombre}}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list> -->
            </v-card>
          </v-menu>

          <div class="pb-1 text-center">
                <span @click="showNeighborhoodsMenu"
                      style="cursor: pointer;"
                      class="hover"
                      :class="[filtros.barrio ? 'select text-caption' : '']" >
                    {{filtros.barrio && filtros.barrio.nombre || 'Barrio'}}
                </span>

            <v-icon @click="filtros.barrio = ''"
                    color="grey lighten-2"
                    size="small"
                    v-if="filtros.barrio">
              clear
            </v-icon>
          </div>

          <v-menu :close-on-click="true"
                  :close-on-content-click="false"
                  max-height="300px"
                  v-model="showNeighborhoodsDialog"
                  :position-x="x"
                  :position-y="y"
                  absolute>
            <v-card tile>
             <v-autocomplete :items="neighborhoods"
                            v-model="neighborhood"
                            item-text="nombre"
                            item-value="id"
                            return-object
                            label="Buscar Barrio"
                            flat
                            solo
                            prepend-inner-icon="mdi-magnify"
                            hide-details
                            no-data-text="No hay datos"
                            @input="setNeighborhoods">
              </v-autocomplete>

              <v-divider/>

            <!--   <v-list>
                <v-list-item @click="closeNeighborhoodsDialog(itemNeighborhood)"
                             dense
                             :key="JSON.stringify(itemNeighborhood)"
                             v-for="itemNeighborhood in neighborhoods">
                  <v-list-item-content>
                    <v-list-item-title>
                      {{itemNeighborhood.nombre}}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list> -->
            </v-card>
          </v-menu>
          </v-row>
          </v-container>
        </template>
        <template v-slot:header.caracteristicas>
           <v-container fluid class="pa-0">
            <v-row align="center" justify="space-around" class="ma-0 flex-column">
         <div class="pb-3">
                    <span @click="showAlcobasMenu"
                          style="cursor: pointer;"
                          class="hover"
                          :class="[filtros.alcobas ? 'select text-caption' : '']" >
                          {{filtros.alcobas || 'Alcobas'}}
                    </span>
            <v-icon @click="filtros.alcobas = ''"
                    color="grey lighten-2"
                    size="small"
                    v-if="filtros.alcobas">
              clear
            </v-icon>
          </div>
          <v-menu :close-on-click=true
                  :close-on-content-click="false"
                  max-height="250px"
                  max-width="150px"
                  v-model="showAlcobasDialog"
                  :position-x="x"
                  :position-y="y"
                  absolute>
            <v-card tile>
              <v-container fluid class="py-0">
              <v-row class="pb-0">
              <v-col cols="12">
              <v-text-field outlined
                            hide-details
                            label="# Alcobas"
                            v-model.number="alcobas"
                            autofocus
                            append-icon="mdi-send"
                            @click:append="setAlcobas"
                            @keyup.enter="setAlcobas">
              </v-text-field>
              </v-col>
              <v-divider></v-divider>
              <v-col class="py-0" align-self="center">
                <v-checkbox label="No Aplica"
                            v-model="sinAlcoba"
                            @click="checkedAlcobas"
                            class="ml-2">
                </v-checkbox>
                </v-col>
                </v-row>
              </v-container>
            </v-card>
          </v-menu>
         <div>
                    <span @click="showPisoMenu"
                          style="cursor: pointer;"
                          class="hover"
                          :class="[filtros.piso ? 'select text-caption' : '']" >
                          {{filtros.piso || 'Piso'}}
                    </span>
            <v-icon @click="filtros.piso = ''"
                    color="grey lighten-2"
                    size="small"
                    v-if="filtros.piso">
              clear
            </v-icon>
          </div>
          <v-menu :close-on-click=true
                  :close-on-content-click="false"
                  max-height="250px"
                  max-width="150px"
                  v-model="showPisoDialog"
                  :position-x="x"
                  :position-y="y"
                  absolute>
            <v-card tile>
              <v-container fluid class="py-0">
              <v-row class="pb-0">
              <v-col cols="12">
              <v-text-field outlined
                            hide-details
                            label="# Piso"
                            v-model="piso"
                            autofocus
                            append-icon="mdi-send"
                            @click:append="setPiso"
                            @keyup.enter="setPiso">
              </v-text-field>
              </v-col>
              <v-divider></v-divider>
              <v-col class="py-0" align-self="center">
                <v-checkbox label="No Aplica"
                            v-model="sinPiso"
                            @click="checkedPiso"
                            class="ml-2">
                </v-checkbox>
                </v-col>
                </v-row>
              </v-container>
            </v-card>
          </v-menu>
          </v-row>
          </v-container>
        </template>

        <template v-slot:header.areas>
          <v-container fluid class="pa-0">
            <v-row align="center" justify="space-around" class="ma-0 flex-column">
          <div class="text-center pb-0">
                    <span @click="showAreaMenu"
                          style="cursor: pointer"
                          class="hover"
                          :class="[filtros.areaDesde ? 'select text-caption' : '']" >
                          {{filtros.areaDesde ? [areaDesde, areaHasta] : 'Área Construída'}}
                    </span>
            <v-icon @click="filtros.areaDesde = ''"
                    color="grey lighten-2"
                    size="small"
                    v-if="filtros.areaDesde">
              clear
            </v-icon>
          </div>
          <v-menu :close-on-click=true
                  :close-on-content-click="false"
                  max-width="200px"
                  v-model="showAreasDialog"
                  :position-x="x"
                  :position-y="y"
                  absolute>
            <v-card tile>
              <v-container class="pt-0 pb-0 pr-0">
              <v-row>
              <v-col cols="8">
              <v-text-field outlined
                            hide-details
                            label="Desde"
                            class="pb-2"
                            v-model="areaDesde"
                            autofocus
                            suffix="m²">
              </v-text-field>
              <v-text-field outlined
                            hide-details
                            label="Hasta"
                            v-model="areaHasta"
                            suffix="m²">
              </v-text-field>
              </v-col>
              <v-col class="pa-0"
                     align-self="center">
                 <v-btn fab
                        dark
                        color="#172B4D"
                        small
                        @click="selectedAreas">
                <v-icon dark>mdi-magnify</v-icon>
              </v-btn>
              </v-col>
              </v-row>
              </v-container>
            </v-card>
          </v-menu>
          <br>

          <div class="text-center">
                    <span @click="showAreaLoteMenu"
                          style="cursor: pointer;"
                          class="hover"
                          :class="[filtros.areaLoteDesde ? 'select text-caption' : '']" >
                          {{filtros.areaLoteDesde ? [areaLoteDesde, areaLoteHasta] : 'Área Lote'}}
                    </span>
            <v-icon @click="filtros.areaLoteDesde = ''"
                    color="grey lighten-2"
                    size="small"
                    v-if="filtros.areaLoteDesde">
              clear
            </v-icon>
          </div>
           <v-menu :close-on-click=true
                  :close-on-content-click="false"
                  max-width="200px"
                  v-model="showAreaLoteDialog"
                  :position-x="x"
                  :position-y="y"
                  absolute>
            <v-card tile>
              <v-container class="pt-0 pb-0 pr-0">
              <v-row>
              <v-col cols="8">
              <v-text-field outlined
                            hide-details
                            label="Desde"
                            class="pb-2"
                            v-model.number="areaLoteDesde"
                            autofocus
                            suffix="m²">
              </v-text-field>
              <v-text-field outlined
                            hide-details
                            label="Hasta"
                            v-model.number="areaLoteHasta"
                            suffix="m²">
              </v-text-field>
              </v-col>
              <v-col class="pa-0"
                     align-self="center">
                 <v-btn fab
                        dark
                        color="#172B4D"
                        small
                        @click="selectedAreasLote">
                <v-icon dark>mdi-magnify</v-icon>
              </v-btn>
              </v-col>
              </v-row>
              </v-container>
            </v-card>
          </v-menu>
          </v-row>
          </v-container>
        </template>

        <template v-slot:header.precios>
          <v-container fluid class="pa-0">
          <v-row align="center" justify="center" class="ma-0">
          <div>
            <span @click="showPreciosMenu"
                  style="cursor: pointer"
                  class="hover">
               <span v-if="!filtros.precioDesde">Precios</span>
               <span v-else class="select text-caption">[{{precioDesde | currency('$', 0, { thousandsSeparator: '.' })}}, <br>
                     {{precioHasta | currency('$', 0, { thousandsSeparator: '.' })}}]
               </span>
            </span>

            <v-icon @click="filtros.precioDesde = ''"
                    color="grey lighten-2"
                    size="small"
                    v-if="filtros.precioDesde">
              clear
            </v-icon>
          </div>

           <v-menu :close-on-click=true
                  :close-on-content-click="false"
                  max-width="240px"
                  v-model="showPreciosDialog"
                  :position-x="x"
                  :position-y="y"
                  absolute>
            <v-card tile class="pr-0">
              <v-container class="py-0 pr-0">
              <v-row>
              <v-col cols="8">
              <v-text-field outlined
                            hide-details
                            label="Desde"
                            class="pb-2"
                            v-model.number="precioDesde"
                            autofocus
                            prefix="$">
              </v-text-field>
              <v-text-field outlined
                            hide-details
                            label="Hasta"
                            v-model.number="precioHasta"
                            prefix="$">
              </v-text-field>
              </v-col>
              <v-col class="pa-0 ma-0"
                     align-self="center">
                 <v-btn fab
                        dark
                        color="#172B4D"
                        small
                        @click="selectedPrecios">
                <v-icon dark>mdi-magnify</v-icon>
              </v-btn>
              </v-col>
              </v-row>
              </v-container>
            </v-card>
          </v-menu>
          </v-row>
          </v-container>
        </template>
        <template v-slot:header.contacto>
          <v-container fluid class="pa-0">
          <v-row align="center" justify="center" class="ma-0">
          <div>
            <span @click="showContactMenu"
                  style="cursor: pointer"
                  class="hover"
                  :class="[filtros.propietario ? 'select text-caption' : '']" >
                  {{filtros.propietario || 'Contacto'}}
            </span>

            <v-icon @click="filtros.propietario = ''"
                    color="grey lighten-2"
                    size="small"
                    v-if="filtros.propietario">
              clear
            </v-icon>
          </div>
           <v-menu :close-on-click=true
                  :close-on-content-click="false"
                  max-height="200px"
                  max-width="250px"
                  v-model="showContactDialog"
                  :position-x="x"
                  :position-y="y"
                  absolute>
            <v-card tile class="pa-3">
              <v-text-field outlined
                            hide-details
                            label="Contacto"
                            v-model="filtros.propietario"
                            autofocus
                            append-icon="mdi-send"
                            @click:append="showContactDialog = false"
                            @keyup.enter="showContactDialog = false">
              </v-text-field>
            </v-card>
          </v-menu>
          </v-row>
          </v-container>
        </template>

        <!-- itemssssss-->

        <template v-slot:item.tipoPropiedad="{ item }" @click="getProperties()">
          <v-container fluid class="pa-0" @click="showProperty(item)" style="cursor: pointer" >
            <v-row class="px-3 pb-1" justify="center">
              <span class="abadPrimary"
                    style="padding: 3px 8px; border-radius: 3px; color: white;">
                {{item.tipoPropiedad}}
              </span>
            </v-row>

            <v-row class="px-3 pb-1" justify="center">
              {{item.codigo}}
            </v-row>

            <v-row class="px-3 text-center" justify="center">
              {{item.estado}}
            </v-row>
          </v-container>
        </template>

        <template v-slot:item.urbanizacion="{ item }">
          <v-row justify="center" class="text-center px-3">
          {{item.urbanizacion}}
          </v-row>
        </template>

        <template v-slot:item.zonas="{ item }">
          <v-container fluid class="pa-0">
            <v-row class="px-3 pb-1 text-center" justify="center">
            {{item.zona}}
            </v-row>
            <v-row class="px-3 pb-1 text-center" justify="center">
            {{item.sector}}
            </v-row>
            <v-row class="px-3 pb-1 text-center" justify="center">
            {{item.barrio}}
            </v-row>
          </v-container>
        </template>

        <template v-slot:item.caracteristicas="{ item }">
          <v-row justify="space-around" class="ma-0 flex-column">
            <div class="pb-2">
              <v-icon small class="mr-2">fas fa-bed</v-icon>
              {{item.alcobas}}
           </div>
           <div>
              <v-icon small class="mr-2">fas fa-building</v-icon>
              {{item.numApto || 'No'}}
          </div>
          </v-row>
        </template>

        <template v-slot:item.areas="{ item }">
          <v-container fluid class="pa-0">
            <v-row class="px-3 pb-2 text-center" justify="center">
          {{item.areaConstruida}} m²
            </v-row>
           <v-row class="px-3 pb-1 text-center" justify="center">
          {{item.areaLote ? `${item.areaLote} m²` : 'Sin datos'}}
            </v-row>
          </v-container>
        </template>

        <template v-slot:item.precios="{ item }">
           <v-row justify="center" class="text-center px-3">
          {{item.valorVenta || item.valorArriendo | currency('$', 0, { thousandsSeparator: '.' })}}
           </v-row>
        </template>

        <template v-slot:item.contacto="{ item }">
          <v-row justify="space-around" class="ma-0 flex-column">
            <div class="mb-2">
            <v-icon small class="mr-2">person</v-icon>{{item.propietario}}
            </div>
            <div>
          <v-icon small class="mr-2">phone</v-icon>{{item.propietarioTelefonos}}
          </div>
          </v-row>
        </template>

        <template v-slot:item.nodata>
          <v-row>
            <v-col class="text-center" cols="12" v-if="loadingProperties">
              Cargando propiedades
            </v-col>
            <v-col cols="12" class="red--text text-center" v-else>
              No hay propiedades registradas
            </v-col>
          </v-row>
        </template>
      </v-data-table>
    </v-col>
  </v-row>
</template>

<script>
import PropertyDetailsDialog from '@/pages/RealEstate/components/PropertyDetailsDialog.vue'
import constants from './libs/constants'
import { mapState } from 'vuex'
import realEstateService from '@/services/realEstateService.js'

export default {
  components: { PropertyDetailsDialog },
  computed: {
    ...mapState({
      neighborhoods: state => state.realEstate.neighborhoods,
      properties: state => state.realEstate.properties,
      sectors: state => state.realEstate.sectors,
      totalProperties: state => state.realEstate.totalProperties,
      zones: state => state.realEstate.zones
    }),
    areaConstruida () {
      if (!this.filtros.areaDesde && !this.filtros.areaHasta) return null
      return `${this.filtros.areaDesde || '0'}-${this.filtros.areaHasta || 999999999999}`
    },
    areaLoteConstruida () {
      if (!this.filtros.areaLoteDesde && !this.filtros.areaLoteHasta) return null
      return `${this.filtros.areaLoteDesde || '0'}-${this.filtros.areaLoteHasta || 999999999999}`
    }
  },
  async created () {
    try {
      await this.$store.dispatch('getZones')
    } catch (e) {
      console.log(e)
    }
  },
  data: () => ({
    filtros: {
      alcobas: '',
      areaDesde: '',
      areaHasta: '',
      areaLoteDesde: '',
      areaLoteHasta: '',
      codigo: '',
      barrio: null,
      piso: '',
      precioDesde: '',
      precioHasta: '',
      propietario: '',
      proposito: '',
      sector: null,
      tipoPropiedad: '',
      urbanizacion: '',
      zona: ''
    },
    footerProps: {
      'items-per-page-options': [],
      'items-per-page-text': 'Propiedades por pagina'
    },
    headers: [
      { value: 'tipoPropiedad', sortable: false },
      { value: 'urbanizacion', sortable: false },
      { value: 'zonas', sortable: false },
      { value: 'caracteristicas', sortable: false },
      { value: 'areas', sortable: false },
      { value: 'precios', sortable: false },
      { value: 'contacto', sortable: false }
    ],
    alcobas: '',
    areaDesde: '',
    areaHasta: '',
    areaLoteDesde: '',
    areaLoteHasta: '',
    codigo: '',
    loadingProperties: false,
    neighborhood: null,
    options: {},
    piso: '',
    precioDesde: '',
    precioHasta: '',
    propertiesTypes: constants.propertiesTypes,
    propetario: '',
    purposeForFilters: constants.purposeForFilters,
    sector: null,
    selectedProperty: '',
    sinPiso: false,
    sinAlcoba: false,
    showAlcobasDialog: false,
    showAreasDialog: false,
    showAreaLoteDialog: false,
    showCodigoDialog: false,
    showContactDialog: false,
    showDetailsDialog: false,
    showNeighborhoodsDialog: false,
    showPreciosDialog: false,
    showPisoDialog: false,
    showSectorsDialog: false,
    showUnidadDialog: false,
    showZonesDialog: false,
    unidad: '',
    unidades: [],
    loading: false,
    show: true,
    showMessage: false,
    x: 0,
    y: 0,
    zona: null
  }),
  methods: {
    async closeNeighborhoodsDialog (barrio) {
      if (!barrio) return
      this.filtros.barrio = barrio
      this.getProperties()
      this.showNeighborhoodsDialog = false
    },
    async getNeighborhoods () {
      try {
        this.showSectorsDialog = false
        this.filtros.barrio = null
        if (this.filtros.sector) {
          await this.$store.dispatch('getNeighborhoods', this.sector)
        } else {
          await this.$store.dispatch('getNeighborhoods', null)
        }
        this.getProperties()
      } catch (e) {
        console.log(e)
      }
    },
    async getProperties () {
      const data = {
        alcobas: this.filtros.alcobas,
        areaDesde: this.filtros.areaDesde,
        areaHasta: this.filtros.areaHasta,
        barrio: this.filtros.barrio ? this.filtros.barrio.id : undefined,
        codigo: this.filtros.codigo,
        propietario: this.filtros.propietario,
        proposito: this.filtros.proposito.value,
        propositoValor: `${this.filtros.precioDesde || '0'}-${this.filtros.precioHasta || '999999999999'}`,
        sector: this.filtros.sector ? this.filtros.sector.id : undefined,
        tipoPropiedad: this.filtros.tipoPropiedad.value,
        urbanizacion: this.filtros.urbanizacion.urbanizacion,
        zona: this.filtros.zona ? this.filtros.zona.id : undefined,
        options: this.options
      }
      await this.$store.dispatch('getProperties', data)
    },
    async getSectors () {
      try {
        this.showZonesDialog = false
        this.filtros.barrio = null
        this.filtros.sector = null
        if (this.filtros.zona) {
          await this.$store.dispatch('getSectors', this.zona)
        } else {
          await this.$store.dispatch('getSectors', null)
        }
        this.getProperties()
      } catch (e) {
        console.log(e)
      }
    },
    async getUnidades (unidad) {
      try {
        this.loading = true
        this.unidades = await realEstateService.getUnidades(unidad)
        this.loading = false
        if (this.unidades.length === 0) {
          this.showMessage = true
        } else {
          this.showMessage = false
        }
      } catch (e) {
        console.log(e)
      }
    },
    checkedAlcobas () {
      this.filtros.alcobas = 'No Aplica'
      if (!this.filtros.alcobas) return
      this.$nextTick(() => {
        this.showAlcobasDialog = false
        this.getProperties()
      })
    },
    checkedPiso () {
      this.filtros.piso = 'No Aplica'
      if (!this.filtros.piso) return
      this.$nextTick(() => {
        this.showPisoDialog = false
        this.getProperties()
      })
    },
    getListUnidades (u) {
      this.filtros.urbanizacion = u
      this.showUnidadDialog = false
      if (!this.filtros.urbanizacion) return
      this.getProperties()
    },
    goto (route) {
      this.$router.push(route)
    },
    resetFilters () {
      this.filtros = {
        alcobas: '',
        codigo: '',
        barrio: null,
        tipoPropiedad: {},
        precioDesde: '',
        precioHasta: '',
        propietario: '',
        proposito: {},
        sector: null,
        urbanizacion: '',
        zona: null
      }

      this.getProperties()
    },
    setAlcobas () {
      this.filtros.alcobas = this.alcobas
      this.showAlcobasDialog = false
      if (!this.filtros.alcobas) return
      this.getProperties()
    },
    setCodigo () {
      this.filtros.codigo = this.codigo
      this.showCodigoDialog = false
      if (!this.filtros.codigo) return
      this.getProperties()
    },
    setNeighborhoods () {
      if (this.neighborhood) {
        this.filtros.barrio = this.neighborhood
        this.$nextTick(() => {
          this.showNeighborhoodsDialog = false
          this.getProperties()
        })
      }
    },
    setPiso () {
      this.filtros.piso = this.piso
      this.showPisoDialog = false
      if (!this.filtros.piso) return
      this.getProperties()
    },
    setSector () {
      if (this.sector) {
        this.filtros.sector = this.sector
        this.$nextTick(() => {
          this.showSectorsDialog = false
          this.getNeighborhoods()
        })
      }
    },
    setZone () {
      if (this.zona) {
        this.filtros.zona = this.zona
        this.$nextTick(() => {
          this.showZonesDialog = false
          this.getSectors()
        })
      }
    },
    selectedAreas () {
      this.filtros.areaDesde = this.areaDesde
      this.filtros.areaHasta = this.areaHasta
      this.showAreasDialog = false
    },
    selectedAreasLote () {
      this.filtros.areaLoteDesde = this.areaLoteDesde
      this.filtros.areaLoteHasta = this.areaLoteHasta
      this.showAreaLoteDialog = false
    },
    selectedPrecios () {
      this.filtros.precioDesde = this.precioDesde
      this.filtros.precioHasta = this.precioHasta
      this.showPreciosDialog = false
    },
    showAlcobasMenu (e) {
      e.preventDefault()
      this.showAlcobasDialog = false
      this.alcobas = ''
      this.x = e.clientX
      this.y = e.clientY
      this.$nextTick(() => {
        this.showAlcobasDialog = true
      })
    },
    showAreaMenu (e) {
      e.preventDefault()
      this.showAreasDialog = false
      this.areaHasta = ''
      this.areaDesde = ''
      this.x = e.clientX
      this.y = e.clientY
      this.$nextTick(() => {
        this.showAreasDialog = true
      })
    },
    showAreaLoteMenu (e) {
      e.preventDefault()
      this.showAreaLoteDialog = false
      this.areaLoteDesde = ''
      this.areaLoteHasta = ''
      this.x = e.clientX
      this.y = e.clientY
      this.$nextTick(() => {
        this.showAreaLoteDialog = true
      })
    },
    showCodigoMenu (e) {
      e.preventDefault()
      this.showCodigoDialog = false
      this.codigo = ''
      this.x = e.clientX
      this.y = e.clientY
      this.$nextTick(() => {
        this.showCodigoDialog = true
      })
    },
    showContactMenu (e) {
      e.preventDefault()
      this.showContactDialog = false
      this.propietario = ''
      this.x = e.clientX
      this.y = e.clientY
      this.$nextTick(() => {
        this.showContactDialog = true
      })
    },
    showNeighborhoodsMenu (e) {
      e.preventDefault()
      this.showNeighborhoodsDialog = false
      this.neighborhood = null
      this.getNeighborhoods()
      this.x = e.clientX
      this.y = e.clientY
      this.$nextTick(() => {
        this.showNeighborhoodsDialog = true
      })
    },
    showPreciosMenu (e) {
      e.preventDefault()
      this.showPreciosDialog = false
      this.precioDesde = ''
      this.precioHasta = ''
      this.x = e.clientX
      this.y = e.clientY
      this.$nextTick(() => {
        this.showPreciosDialog = true
      })
    },
    showProperty (item) {
      this.selectedProperty = item.codigo
      this.showDetailsDialog = true
    },
    showSectorsMenu (e) {
      e.preventDefault()
      this.showSectorsDialog = false
      this.sector = null
      this.barrio = null
      this.getSectors()
      this.x = e.clientX
      this.y = e.clientY
      this.$nextTick(() => {
        this.showSectorsDialog = true
      })
    },
    showZonesMenu (e) {
      e.preventDefault()
      this.zona = null
      this.barrio = null
      this.sector = null
      this.showZonesDialog = false
      this.x = e.clientX
      this.y = e.clientY
      this.$nextTick(() => {
        this.showZonesDialog = true
      })
    },
    showUnidadMenu (e) {
      e.preventDefault()
      this.showUnidadDialog = false
      this.show = false
      this.unidad = ''
      this.unidades = []
      this.loading = false
      this.x = e.clientX
      this.y = e.clientY
      this.$nextTick(() => {
        this.showUnidadDialog = true
      })
    },
    showPisoMenu (e) {
      e.preventDefault()
      this.showPisoDialog = false
      this.piso = ''
      this.sinPiso = false
      this.x = e.clientX
      this.y = e.clientY
      this.$nextTick(() => {
        this.showPisoDialog = true
      })
    },
    reset () {
      this.unidades = []
      this.unidad = ''
    }
  },
  watch: {
    options: {
      handler () {
        this.getProperties()
        this.$vuetify.goTo(0)
      },
      deep: true
    },
    filtros: {
      handler () {
        this.options.page = 1
        this.getProperties()
      },
      deep: true
    }
  }
}
</script>

<style scoped>
  .custom-input {
    color: white;
    font-weight: 400;
    text-transform: uppercase;
  }
  .custom-input::placeholder {
    color: white !important;
  }

  ::v-deep .custom-table th {
    padding: 12px 12px !important;
  }
  ::v-deep .custom-table td{
    padding: 12px 12px !important;
  }
  .hover:hover {
    color: #E0E0E0;
  }
  .hover1:hover {
    background-color: #BDBDBD;
  }
  .select {
    color: #E0E0E0;
  }
  ::v-deep .v-list-item__title {
    font-size: 0.8125rem !important;
    font-weight: 500 !important;
  }
  ::v-deep .v-list-item__content {
    padding: 8px 0 !important;
  }
</style>
